import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class HeadersInterceptor implements HttpInterceptor {
    constructor(private router: Router) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const currentRoute = this.router.url;

        if (currentRoute.includes('private') && !req.url.includes('parameters')) {
            const token = localStorage.getItem('auth_token');
            const authReq = token
                ? req.clone({
                      setHeaders: { Authorization: `Bearer ${token}` },
                  })
                : req;
            return next.handle(authReq);
        } else {
            return next.handle(req);
        }
    }
}
